import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import NewsletterSubscription from "@/components/layout/NewsletterSubscription";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="flex flex-col min-h-screen">
        <main className="flex-1 flex items-center justify-center">
          <div className="text-center space-y-6 px-4">
            <h1 className="text-6xl font-bold text-primary">404</h1>
            <p className="text-2xl text-muted-foreground">Oops! Page not found</p>
            <Link 
              to="/" 
              className="inline-block bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-3 rounded-lg font-semibold transition-colors"
            >
              Return to Home
            </Link>
          </div>
        </main>
        <NewsletterSubscription />
      </div>
    </div>
  );
};

export default NotFound;
